// API client
import axios from 'axios';

// Use relative path so it works with the proxy in development
// In production, this would need to point to the actual backend URL
const API_URL = '/api';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
